// Webpack imports will execute the module's code, but variables are not exposed globally.
import 'jquery';
import 'pages';
import 'vendor';
import 'styleguide';
import 'shared';
import 'helpers';
import 'widgets';
import 'experiments';


// This is an anti-pattern of Webpack. Webpack generally does not expose
// to global scope. When we used Sprockets, everything was exposed globally
// and there exists snippets in views that rely on this. So, for backwards
// compatability, we have to expose these globally using `window.`
window.Cookies = require('vendor/js.cookie');


// jQuery (and other 3rd party modules) can expose internal variables globally
// using Webpack's `expose-loader`. No need for `window.` TODO: Ideally, we use
// `expose-loader` for internal modules as well.
jQuery.cachedScript = function(url){
  return jQuery.ajax({
   dataType: "script",
   cache: true,
   url: url
 });
};
